import { supabase } from '../lib/supabase';
import type { Job } from '../types/models';

export async function uploadJob(title: string, description: string, company: string = ''): Promise<Job> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('Not authenticated');
    }

    // Get user's organization ID
    const { data: member } = await supabase
      .from('organization_members')
      .select('organization_id')
      .eq('user_id', user.id)
      .maybeSingle();

    if (!member?.organization_id) {
      throw new Error('User must be part of an organization to upload jobs');
    }

    const { data, error } = await supabase
      .from('jobs')
      .insert([{
        title,
        jd_text: description,
        company,
        user_id: user.id,
        organization_id: member.organization_id
      }])
      .select()
      .maybeSingle();

    if (error) {
      console.error('Upload error:', error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Upload job error:', error);
    throw new Error(`Failed to upload job: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

export async function listJobs(): Promise<Job[]> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('Not authenticated');
    }

    // Get user's organization ID
    const { data: member } = await supabase
      .from('organization_members')
      .select('organization_id')
      .eq('user_id', user.id)
      .maybeSingle();

    if (!member?.organization_id) {
      // Return empty array if user has no organization yet
      return [];
    }

    const { data, error } = await supabase
      .from('jobs')
      .select('id, title, jd_text, company, created_at')
      .eq('organization_id', member.organization_id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Get jobs error:', error);
    throw new Error('Failed to fetch jobs');
  }
}